import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import SidebarItem from "./sidebarItem";
import { useMaterialUIController, setMiniSidebar } from "context";
import routes from "routes";

const Sidebar = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { user, miniSidebar } = controller;
  const toggleSidebar = () => setMiniSidebar(dispatch, !miniSidebar);

  return (
    <Box
      sx={{
        width: miniSidebar ? "250px" : "80px",
        height: "100%",
        flexGrow: 1,
        backgroundColor: "#333333",
        display: "flex",
        flexDirection: "column",
        alignItems: miniSidebar ? "flex-start" : "center",
        pt: 2,
        pl: 1,
        pr: 1,
        mt: 0,
        overflowY: "auto",
        overflowX: "hidden",
        transition: "width 0.3s ease-in-out",
        scrollbarWidth: "thin",
        scrollbarColor: "#ffffffrgba(68, 68, 68, 0.45)",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#ffffff",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#444444",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: miniSidebar ? "flex-start" : "center",
          width: "100%",
          cursor: "pointer",
          paddingLeft: miniSidebar ? "0px" : "0",
          mb: 3,
          mt: 1,
        }}
        onClick={toggleSidebar}
      >
        <Box
          component="div"
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "#333333",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="white" d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" />
          </svg>
        </Box>
        {miniSidebar && (
          <Typography
            variant="h6"
            sx={{
              ml: 2,
              color: "#FFFFFF",
              fontWeight: "700",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textShadow: "1px 1px 4px #E59400",
              letterSpacing: "1px",
            }}
          >
            KOTA HOLDINGS
          </Typography>
        )}
      </Box>
      {(user?.menu || []).map((route, index) => (
        <SidebarItem key={index} item={route} isExpanded={miniSidebar} />
      ))}
    </Box>
  );
};

export default Sidebar;
